import { useCallback, useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Form,
  Row,
  Col,
  Button,
  Label,
  FormGroup
} from 'reactstrap';
import { X, PlayCircle } from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import classnames from 'classnames';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GetLiveLink } from '../../../../graphql/Query/settings';
import { UpdateLiveLink } from '../../../../graphql/Mutation/settings';
const LiveImage = require('../../../../assets/images/live/live.svg').default;

// ** Schema yup
const Schema = yup.object().shape({
  liveLink: yup.string().required('Ingresa un link')
});

const CustomModal = ({ renderCloseBtn, toggleSidebar, open }) => {
  const [livePremium, setLivePremium] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    liveLink: '',
    isLive: false
  });
  const [getLiveLink] = useLazyQuery(GetLiveLink, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  });
  const [updateLiveLink] = useMutation(UpdateLiveLink);

  const handleFetch = useCallback(async () => {
    const {
      data: { getFullSettings: data }
    } = await getLiveLink();
    setDefaultValues({ ...data, __typename: undefined });
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await updateLiveLink({
        variables: {
          data: {
            liveLink: values.isLive ? '' : values.liveLink,
            isLive: !values.isLive,
            livePremium
          }
        }
      });
      toggleSidebar();
    } catch (e) {
      setSubmitting(false);
    }
  };

  const seletLivePremium = async (e) =>  {
    setLivePremium(e.target.checked);
  };

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  return (
    <Modal
      isOpen={open}
      toggle={toggleSidebar}
      fullscreen="lg"
      className="mt-5"
    >
      <ModalHeader toggle={toggleSidebar} close={renderCloseBtn} tag="div" />
      <PerfectScrollbar options={{ wheelPropagation: false }}>
        <ModalBody
          className={classnames('flex-grow-1')}
          style={{
            padding: 30
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={LiveImage} />
            <span
              style={{
                color: '#6A6B89',
                fontSize: 18,
                fontWeight: 'bold'
              }}
            >
              Link Transmisión en Vivo
            </span>
          </div>
          <Formik
            enableReinitialize
            onSubmit={handleSubmit}
            initialValues={defaultValues}
            validateOnChange
            validateOnBlur
            validationSchema={Schema}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md="12">
                    <Label for="liveLink">Link de Transmisión</Label>
                    <Input
                      id="liveLink"
                      name="liveLink"
                      placeholder="https://..."
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.liveLink}
                      disabled={values.isLive}
                      invalid={errors.liveLink && true}
                    />
                  </Col>

                  <Col md="8">
                    <FormGroup check>
                      <Input                      
                        name="livePremium"
                        type="checkbox"
                        value='livePremium'
                        checked={livePremium} 
                        onChange={seletLivePremium}
                        onBlur={handleBlur}
                        id='livePremium'
                      />
                      <Label className="form-label" for="other">
                        Premium
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                      className="mt-2 w-100"
                    >
                      {defaultValues.isLive ? 'Finalizar' : 'Crear'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}

          </Formik>
          <div></div>
        </ModalBody>
      </PerfectScrollbar>
    </Modal>
  );
};

const LiveComponent = () => {
  const [open, setOpen] = useState(false);

  const toggleSidebar = () => {
    setOpen(!open);
  };

  // ** If user passes custom close btn render that else default close btn
  const renderCloseBtn = (
    <X className="cursor-pointer" size={15} onClick={toggleSidebar} />
  );

  return (
    <>
      {open && (
        <CustomModal
          open={open}
          renderCloseBtn={renderCloseBtn}
          toggleSidebar={toggleSidebar}
        />
      )}
      <div
        onClick={() => setOpen(!open)}
        style={{
          color: '#7367f0',
          fontWeight: 'bold',
          marginRight: 30
        }}
        className="d-flex align-items-center justify-content-center"
      >
        <PlayCircle
          color="#7367f0"
          size={30}
          style={{
            marginRight: 10
          }}
        />
        EN VIVO
      </div>
    </>
  );
};

export default LiveComponent;
